const colors = {
    theme : {
        bg_color1 : '#154352',
        bg_color2 : '#113643',
        bg_color3 : '#0f313d',
        bg_color4 : '#16252b',
        bg_color5 : '#131f24',
        bg_color6 : '#eb516c',
        bg_color7 : '#0095b7',
        bg_color8 : '#00b4c1',
        bg_color9 : '#00bec4',
        bg_color10 : '#00a6bc',
        bg_color11 : '#04687a',
        bg_color12 : '#bcb82e',
        bg_color13 : '#5abc2e',
        bg_color14 : '#00d8e8',
        bg_color15 : '#ffffff',
        bg_color16 : '#ffdf00',
        bg_color17 : '#547988',
        bg_color18 : '#04245B',

        btn_bg_color : '#2a6173',
        btn_bg_color1 : '#ffffff',
        btn_bg_color2 : '#0095b7',
        btn_bg_color3 : '#0f313d',
        btn_bg_color4 : '#eb516c',


        btn_font_color : '#ffffff',
        btn_font_color2 : '#2a6173',
        btn_font_color3 : '#32a2c6',
        btn_font_color4 : '#547988',
        btn_font_color5 : '#01a6bc',
        btn_font_color6 : '#ffdf00',

        btn_txt_font_color : '#00ccc8',

        btn_border : '#00b4c1',
        btn_border1 : '#5cafc8',
        btn_border2 : '#234c5b',
        btn_border3 : '#04687a',
        btn_border4 : '#ffffff',

        border_color : '#6c7376',
        border_color2 : '#eb516c',
        border_color3 : '#ffffff',

        input_underline : '#00b4c1',
        input_text_color : '#ffffff',
        input_place_holder_color : '#bac2c6',
        input_place_holder_color1 : '#6092a4',
        input_underline_color : '#00b4c1',
        input_underline_color2 : '#ffffff',
        input_underline_color_error : '#eb516c',

        txt_color : '#ffffff',
        txt_color1 : '#5bddfa',
        txt_color3 : '#0f313d',
        txt_color4 : '#eb516c',
        txt_color5 : '#00a7bc',
        txt_color6 : '#0f3039',

        tab_active_color : '#eb516c',
        tab_inactive_color : '#00bfc4',
        tab_active_color1 : '#eb516c',
        tab_inactive_color1 : '#ffffff',
        tab_count_bg1 : '#0f313d',
        tab_count_bg2 : '#eb516c',
        tab_count_txt_color1 : '#00bfc4',
        tab_count_txt_color2 : '#ffffff',
        tab_border_color : '#15414f',

        sidebar_border_color1 : '#000000',
        sidebar_border_color2 : '#2f505d',
        sidebar_border_color3 : '#41555c',
    },
    theme2 : {
        bg_color1 : 'rgb(255, 255, 255)',
        bg_color2 : 'rgb(46,108,211)',
        bg_color3 : 'rgb(65,124,213)',
        bg_color4 : 'rgb(240, 69, 113)',
        bg_color5 : 'rgb(95 ,159, 255)',
        bg_color6 : 'rgb(0 ,0, 0)',
        bg_color7 : 'rgba(23,50, 114, 0.6)',
        bg_color8 : 'rgb(4,36,91)',
        bg_color9 : 'rgb(17,71,171)',
        bg_color10 : 'rgb(247, 247, 247)',
        bg_color11 : 'rgba(155, 155, 155, 0.5)',



        font_color1 : 'rgb(0, 0, 0)',
        font_color2 : 'rgb(135, 135, 135)',
        font_color3 : 'rgb(255, 255, 255)',
        font_color4 : 'rgb(23,50,114)',
        font_color5 : 'rgb(155,155,155)',

        border_color1 : 'rgb(227,233,236)',
        border_color2 : 'rgb(89,123,180)',

    }
};

export {colors};


// WEBPACK FOOTER //
// ./src/app/config/colors.js